<template>
  <div class="app" :class="{'energy-default': themeCode === 'default', 'energy': themeCode === 'blue'}">
    <div class="energy-content">
      <div class="energy-content-left">
        <div class="energy-title">{{ $t('energy.energy.528939-0') }}</div>
        <div class="map-left-search">
          <img @click="searchDevice" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABaElEQVQ4jY2TsUtVYRjGf95Eu6DkxYi7uEaGQQqBNASB2tYkBNEYCEWLOLm1BgX+B4I4dsEhFGlpaXFQCgeXCKUQDAWxaBB/8cV79fPck90HHjjne9734fB8z+lQyXANeAhMALeAKvAF+AA0gM8UkQyC4+qaZ9hVv2bvB+qM2pXtnBo8UPdjcFV9rI6oN0ObU49Df1U0qKufQnyjXskHMibTXzE3mRs8jcMVtbdkMefLmH2vVpsG79QT9UnJQpED6pH6XR1OWgW4ARwCWy0Jt+IbsAn0A7WkJoOTdBnx3A4u5TOVcOwDrrexPAAMAT+AvabB2xCngN6WlfN4AXQDG1GwvyHWsgLNq1dLwkt8rv5Wf0bpzhXprrodJpvqtHpPHVUfqY2skbNqZ9Eg8Y76MRssYkedUl+rS80vLf5MPcAkcB+oR+LpiteBBWAfWIvAl4FnF5Um/TSXS84H88z+17x/8ba6qI79Ac8cMX/xveWyAAAAAElFTkSuQmCC"
            :alt="$t('energy.energy.528939-1')">
          <input @keyup.enter="searchDevice" type="text" v-model="OwnerName" :placeholder="$t('energy.energy.528939-2')" />
        </div>
        <div class="report-content-left-lists">
          <div v-for="item in RoshRoomAllList" :key="item.Id">
              <div class="report-content-left-item" :class="{'map-left-lists-society-unselected':expandItem.Id === item.Id}" @click="expandClick(item)">
                <div class="report-content-left-item-view">
                  <div class="report-content-left-item-view-inco ">
                    <img :src="require('../../../assets/electricity/room.png')" />
                  </div>
                  <div class="report-content-left-item-view-device">
                    <div class="device-text">{{item.OwnerName}}</div>
                    <div class="device-code">{{item.AddressDetail || '-'}}</div>
                  </div>
                </div>
                <div class="report-content-left-item-img">
                  <img src="../../../assets/electricity/arrow.png" alt="">
                </div>
            </div>
            <div class="report-content-left-lisk" v-if="expandItem.Id === item.Id">
              <div class="report-content-left-lisk-item" :class="{'report-content-left-lisk-select':deviceItem.Id === item.Id}" v-for="(item) in DeviceLists" :key="item.Id" @click="selectDevice(item)">
                <div class="item-detail">
                  <div class="report-content-left-lisk-item-inco mapRightRroupListItemImgColor1">
                    <img v-if="item.DeviceId == '6ee95d23-a802-4bd8-b823-19c0944ac5ab'" :src="item.IsOnline ? require('../../../assets/electricity/weiduan.png') : require('../../../assets/electricity/weiduan1.png')" />
                    <img v-if="item.DeviceId == '4782d02c-0075-4105-9729-aa1b65bb250a'" :src="item.IsOnline ? require('../../../assets/electricity/yangan.png') : require('../../../assets/electricity/yangan1.png')" />
                    <img v-if="item.DeviceId == '88f5c429-49b6-4a9f-a908-b2ee9c8cb857'" :src="item.IsOnline ? require('../../../assets/electricity/qigan.png') : require('../../../assets/electricity/qigan1.png')" />
                    <img v-if="item.DeviceId == '7febbea4-0326-496d-9b71-5b058729cb42'" :src="item.IsOnline ? require('../../../assets/electricity/chuanganqi.png') : require('../../../assets/electricity/chuanganqi1.png')" />
                  </div>
                  <div class="report-content-left-lisk-item-device">
                    <div class="device-name">{{item.UserDeviceName}}</div>
                    <div class="device-id">{{item.DeviceCode}}</div>
                  </div>
                </div>
                <div class="item-arrow">
                  <img src="data:image/png;base64,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"
                                        alt="">
                </div>
              </div>
              <div class="map-right-group-list-none1" v-if="!DeviceLists.length">{{ $t('energy.energy.528939-3') }}</div>
            </div>
          </div>

        </div>

        <div class="report-content-left-page">
          <Page :total="TotalCount" @on-change="deviceChange" size="small" />
        </div>
      </div>
      <div class="energy-content-right">
        <div class="energy-content-r-top">
          <div>
            <Select style="width:10vw" v-model="type">
              <Option value="ri">{{ $t('energy.energy.528939-4') }}</Option>
              <Option value="yue">{{ $t('energy.energy.528939-5') }}</Option>
              <Option value="nian">{{ $t('energy.energy.528939-6') }}</Option>
            </Select>
          </div>
          <div>
            <DatePicker v-if="type=='ri'" type="date" v-model="dt" :placeholder="$t('energy.energy.528939-7')" style="width: 10vw"></DatePicker>
            <DatePicker v-else-if="type=='yue'" type="month" v-model="dt" :placeholder="$t('energy.energy.528939-7')" style="width: 10vw"></DatePicker>
            <DatePicker v-else type="year" v-model="dt" :placeholder="$t('energy.energy.528939-7')" style="width: 10vw"></DatePicker>
          </div>
          <div>
            <Button type="primary" @click="inquireClick">{{ $t('energy.energy.528939-8') }}</Button>
          </div>
          <div>
            <Button type="success" @click="exportClick">{{ $t('energy.energy.528939-9') }}</Button>
          </div>
        </div>
        <div class="energy-content-r-content">
          <div class="r-content-left">
            <dv-border-box-7 :color="themeCode === 'default' ? ['#46758b', '#46857b'] : ['#092768', '#28449D']" :backgroundColor="themeCode === 'default' ? 'rgba(83,134,123,0.5)' : 'rgba(2,10,57,0.3)'">
              <div class="energy-title">{{ $t('energy.energy.528939-10') }}</div>
              <div class="energy-compared-view">
                <div class="energy-compared-view-item">
                  <dv-border-box-2 :color="themeCode === 'default' ? ['#46958b', '#46857b'] : ['#0A3779', '#28449D']" :backgroundColor="themeCode === 'default' ? 'rgba(83,134,123,0.5)' : 'rgba(2,10,57,0.6)'">
                    <div class="energy-compared-view-item-text">{{ $t('energy.energy.528939-11') }}</div>
                    <div class="energy-compared-view-item-count">{{NengHaoDuiBiItem.today || 0}}</div>
                  </dv-border-box-2>
                </div>
                <div class="energy-compared-view-item">
                  <dv-border-box-2 :color="themeCode === 'default' ? ['#46958b', '#46857b'] : ['#0A3779', '#28449D']" :backgroundColor="themeCode === 'default' ? 'rgba(83,134,123,0.5)' : 'rgba(2,10,57,0.6)'">
                    <div class="energy-compared-view-item-text">{{ $t('energy.energy.528939-12') }}</div>
                    <div class="energy-compared-view-item-count">{{NengHaoDuiBiItem.yesterday || 0}}</div>
                  </dv-border-box-2>
                </div>
                <div class="energy-compared-view-item">
                  <dv-border-box-2 :color="themeCode === 'default' ? ['#46958b', '#46857b'] : ['#0A3779', '#28449D']" :backgroundColor="themeCode === 'default' ? 'rgba(83,134,123,0.5)' : 'rgba(2,10,57,0.6)'">
                    <div class="energy-compared-view-item-textview">
                      <div class="energy-compared-view-item-text">{{ $t('energy.energy.528939-13') }}</div>
                      <div class="energy-compared-view-item-arrow">
                        <img v-if="NengHaoDuiBiItem.today > NengHaoDuiBiItem.yesterday" src="../../../assets/report/arrow-top.png"
                          alt="">
                        <img v-else src="../../../assets/report/arrow-bottom.png" alt="">
                      </div>
                    </div>
                    <div class="energy-compared-view-item-view">
                      <div class="compared-molecular" :class="{'compared-molecular2' : NengHaoDuiBiItem.today > NengHaoDuiBiItem.yesterday, 'compared-molecular1' : NengHaoDuiBiItem.today <= NengHaoDuiBiItem.yesterday}">{{((NengHaoDuiBiItem.today - NengHaoDuiBiItem.yesterday) || 0).toFixed(2)}}</div>
                      <div class="compared-denominator" :class="{'compared-denominator2' : NengHaoDuiBiItem.today > NengHaoDuiBiItem.yesterday, 'compared-denominator1' : NengHaoDuiBiItem.today <= NengHaoDuiBiItem.yesterday}">{{NengHaoDuiBiItem.yesterday != 0 ? ((((NengHaoDuiBiItem.today - NengHaoDuiBiItem.yesterday) / NengHaoDuiBiItem.yesterday * 100) || 0).toFixed(2)) : 0}}%</div>
                    </div>
                  </dv-border-box-2>
                </div>
                <div class="energy-compared-view-item">
                  <dv-border-box-2 :color="themeCode === 'default' ? ['#46958b', '#46857b'] : ['#0A3779', '#28449D']" :backgroundColor="themeCode === 'default' ? 'rgba(83,134,123,0.5)' : 'rgba(2,10,57,0.6)'">
                    <div class="energy-compared-view-item-text">{{ $t('energy.energy.528939-14') }}</div>
                    <div class="energy-compared-view-item-count">{{NengHaoDuiBiItem.thisMonth || 0}}</div>
                  </dv-border-box-2>
                </div>
                <div class="energy-compared-view-item">
                  <dv-border-box-2 :color="themeCode === 'default' ? ['#46958b', '#46857b'] : ['#0A3779', '#28449D']" :backgroundColor="themeCode === 'default' ? 'rgba(83,134,123,0.5)' : 'rgba(2,10,57,0.6)'">
                    <div class="energy-compared-view-item-text">{{ $t('energy.energy.528939-15') }}</div>
                    <div class="energy-compared-view-item-count">{{NengHaoDuiBiItem.lastMonth || 0}}</div>
                  </dv-border-box-2>
                </div>
                <div class="energy-compared-view-item">
                  <dv-border-box-2 :color="themeCode === 'default' ? ['#46958b', '#46857b'] : ['#0A3779', '#28449D']" :backgroundColor="themeCode === 'default' ? 'rgba(83,134,123,0.5)' : 'rgba(2,10,57,0.6)'">
                    <div class="energy-compared-view-item-textview">
                      <div class="energy-compared-view-item-text">{{ $t('energy.energy.528939-13') }}</div>
                      <div class="energy-compared-view-item-arrow">
                        <img v-if="NengHaoDuiBiItem.thisMonth > NengHaoDuiBiItem.lastMonth" src="../../../assets/report/arrow-top.png"
                          alt="">
                        <img v-else src="../../../assets/report/arrow-bottom.png" alt="">
                      </div>
                    </div>
                    <div class="energy-compared-view-item-view">
                      <div class="compared-molecular" :class="{'compared-molecular2' : NengHaoDuiBiItem.thisMonth > NengHaoDuiBiItem.lastMonth, 'compared-molecular1' : NengHaoDuiBiItem.thisMonth <= NengHaoDuiBiItem.lastMonth}">{{((NengHaoDuiBiItem.thisMonth - NengHaoDuiBiItem.lastMonth) || 0).toFixed(2)}}</div>
                      <div class="compared-denominator" :class="{'compared-denominator2' : NengHaoDuiBiItem.thisMonth > NengHaoDuiBiItem.lastMonth, 'compared-denominator1' : NengHaoDuiBiItem.thisMonth <= NengHaoDuiBiItem.lastMonth}">{{NengHaoDuiBiItem.lastMonth != 0 ? ((((NengHaoDuiBiItem.thisMonth - NengHaoDuiBiItem.lastMonth) / NengHaoDuiBiItem.lastMonth * 100) || 0).toFixed(2)) : 0}}%</div>
                    </div>
                  </dv-border-box-2>
                </div>
                <div class="energy-compared-view-item">
                  <dv-border-box-2 :color="themeCode === 'default' ? ['#46958b', '#46857b'] : ['#0A3779', '#28449D']" :backgroundColor="themeCode === 'default' ? 'rgba(83,134,123,0.5)' : 'rgba(2,10,57,0.6)'">
                    <div class="energy-compared-view-item-text">{{ $t('energy.energy.528939-16') }}</div>
                    <div class="energy-compared-view-item-count">{{NengHaoDuiBiItem.thisYear || 0}}</div>
                  </dv-border-box-2>
                </div>
                <div class="energy-compared-view-item">
                  <dv-border-box-2 :color="themeCode === 'default' ? ['#46958b', '#46857b'] : ['#0A3779', '#28449D']" :backgroundColor="themeCode === 'default' ? 'rgba(83,134,123,0.5)' : 'rgba(2,10,57,0.6)'">
                    <div class="energy-compared-view-item-text">{{ $t('energy.energy.528939-17') }}</div>
                    <div class="energy-compared-view-item-count">{{NengHaoDuiBiItem.lastYear || 0}}</div>
                  </dv-border-box-2>
                </div>
                <div class="energy-compared-view-item">
                  <dv-border-box-2 :color="themeCode === 'default' ? ['#46958b', '#46857b'] : ['#0A3779', '#28449D']" :backgroundColor="themeCode === 'default' ? 'rgba(83,134,123,0.5)' : 'rgba(2,10,57,0.6)'">
                    <div class="energy-compared-view-item-textview">
                      <div class="energy-compared-view-item-text">{{ $t('energy.energy.528939-13') }}</div>
                      <div class="energy-compared-view-item-arrow">
                        <img v-if="NengHaoDuiBiItem.thisYear > NengHaoDuiBiItem.lastYear" src="../../../assets/report/arrow-top.png"
                          alt="">
                        <img v-else src="../../../assets/report/arrow-bottom.png" alt="">
                      </div>
                    </div>
                    <div class="energy-compared-view-item-view">
                      <div class="compared-molecular" :class="{'compared-molecular2' : NengHaoDuiBiItem.thisYear > NengHaoDuiBiItem.lastYear, 'compared-molecular1' : NengHaoDuiBiItem.thisYear <= NengHaoDuiBiItem.lastYear}">{{((NengHaoDuiBiItem.thisYear - NengHaoDuiBiItem.lastYear) || 0).toFixed(2)}}</div>
                      <div class="compared-denominator" :class="{'compared-denominator2' : NengHaoDuiBiItem.thisYear > NengHaoDuiBiItem.lastYear, 'compared-denominator1' : NengHaoDuiBiItem.thisYear <= NengHaoDuiBiItem.lastYear}">{{NengHaoDuiBiItem.lastYear != 0 ? ((((NengHaoDuiBiItem.thisYear - NengHaoDuiBiItem.lastYear) / NengHaoDuiBiItem.lastYear * 100) || 0).toFixed(2)) : 0}}%</div>
                    </div>
                  </dv-border-box-2>
                </div>
              </div>
            </dv-border-box-7>
          </div>
          <div class="r-content-right">
            <dv-border-box-7 :color="themeCode === 'default' ? ['#46758b', '#46857b'] : ['#092768', '#28449D']" :backgroundColor="themeCode === 'default' ? 'rgba(83,134,123,0.5)' : 'rgba(2,10,57,0.3)'">
              <div class="energy-title">{{ $t('energy.energy.528939-18') }}</div>
              <div class="energy-time-echarts">
                <div id="initTimeEcharts" style="width: 100%; height: 100%;"></div>
              </div>
            </dv-border-box-7>
          </div>
        </div>
        <div class="energy-content-r-footer">
          <div class="r-footer-left">
            <dv-border-box-7 :color="themeCode === 'default' ? ['#46758b', '#46857b'] : ['#092768', '#28449D']" :backgroundColor="themeCode === 'default' ? 'rgba(83,134,123,0.5)' : 'rgba(2,10,57,0.3)'">
              <div class="energy-title">{{ $t('energy.energy.528939-19') }}</div>
              <div class="energy-time-echarts">
                <div id="initEnergyEcharts" style="width: 100%; height: 100%;"></div>
              </div>
            </dv-border-box-7>
          </div>
          <div class="r-footer-right">
            <dv-border-box-7 :color="themeCode === 'default' ? ['#46758b', '#46857b'] : ['#092768', '#28449D']" :backgroundColor="themeCode === 'default' ? 'rgba(83,134,123,0.5)' : 'rgba(2,10,57,0.3)'">
              <div class="energy-title">{{ $t('energy.energy.528939-20') }}</div>
              <div class="energy-ranking">
                <div class="map-bottom-content-tab">
                  <div class="map-bottom-content-tab-item">{{ $t('energy.energy.528939-21') }}</div>
                  <div class="map-bottom-content-tab-item">{{ $t('energy.energy.528939-22') }}</div>
                  <div class="map-bottom-content-tab-item">{{ $t('energy.energy.528939-23') }}</div>
                  <div class="map-bottom-content-tab-item tabHandle">{{ $t('energy.energy.528939-24') }}</div>
                </div>
                <div class="map-bottom-list">
                  <div class="map-bottom-lists" v-if="DeviceElecRankLists.length > 0">
                    <div class="map-bottom-list-item" v-for="(item) in DeviceElecRankLists" :key="item.DeviceCode">
                      <div class="map-bottom-list-item-device">{{item.UserDeviceName}}</div>
                      <div class="map-bottom-list-item-addr">{{item.DeviceCode}}</div>
                      <div class="map-bottom-list-item-date">{{item.Etotal}}</div>
                      <div class="map-bottom-list-item-handle">{{item.DianYa}}</div>
                    </div>
                  </div>
                  <div v-else class="map-right-group-list-none">{{ $t('energy.energy.528939-3') }}</div>
                </div>
                <div class="user-top-list-page">
                  <Page :total="ElecTotalCount"
                  :current="ElecRankPageIndex"
                  :page-size="ElecRankPageSize"
                  @on-change="EtotalIndexChange"
                  @on-page-size-change="EtotalSizeChange"
                  size="small" show-elevator show-sizer placement="top" show-total/>
                </div>
              </div>
            </dv-border-box-7>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import echarts from 'echarts'
  import Cookies from 'js-cookie'
  import api from '../../../api/request.js'
  export default {
    data() {
      return {
        pageIndex: 1,
        pageSize: 10,
        OwnerName: '',
        DeviceLists: [], // 设备列表
        TotalCount: 0, // TotalCount
        deviceItem: {
          Id: '',
          DeviceCode: '',
          DeviceName: '',
        },
        NengHaoDuiBiItem: {},
        TongJiByShowHour: [], // 时分ShowHour
        TongJiByEtotal: [], // 时分Etotal

        type: 'ri', // 日期类型
        dt: '', // 日期
        ElecRankPageIndex: 1,
        ElecRankPageSize: 10,
        DeviceElecRankLists: [],
        ElecTotalCount: 0,

        RoshRoomAllList: [],
        expandItem: {},
        initState: true, // 是否首次进入页面

        themeCode: '',

      }
    },

    created() {
			let _this = this;
			_this.themeCode = _this.$store.getters.getThemeCode;
		},

    computed: {

    },

    mounted() {
      let _this = this;
      _this.GetRoshRoomAll();
    },

    methods: {

      // 加载导航栏用户列表
			GetRoshRoomAll() {

        if (!Cookies.get('AdminData')) {
          if (window.location.host == 'xed.hxpwr.com') {
            this.$router.push({
              name: 'xed_login'
            })
          } else {
            this.$router.push({
              name: 'login'
            })
          }
          return;
        }

				let _this = this,
					AdminData = JSON.parse(Cookies.get('AdminData'));

				let data = {
					Status: 'A',
					GroupCode: AdminData.GroupCode,
					CompanyCode: AdminData.CompanyCode,
					DepartmentCode: AdminData.DepartmentCode,
					pageIndex: _this.pageIndex,
					pageSize: _this.pageSize,
          OwnerName: _this.OwnerName
				}
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: 'api/User/GetRoshRoomAll',
					data: data,
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('Token')
					}
				}).then(function(res) {
          _this.RoshRoomAllList = res.Data;
          _this.TotalCount = res.TotalCount;

          if (_this.initState && _this.RoshRoomAllList.length) {
            _this.expandClick(_this.RoshRoomAllList[0], 'init')
            _this.initState = false
          }

				}).catch(function(err) {

				});
			},

      expandClick(item, type = '') {
        if (item.Id !== this.expandItem.Id) {
          this.expandItem = item;
          this.GetUserDevicesPage(type)
        } else {
          this.expandItem = {}
        }

      },

      // 根据集团 公司 部门编号 等条件查询设备列表
      GetUserDevicesPage(type = '') {
				let AdminData = JSON.parse(Cookies.get('AdminData'));
        let _this = this;
        api({
          //这里是你自己的请求方式、url和data参数
          method: 'get',
          url: `api/CommElecDevice/GetUserDevicesPage?isAdmin=${AdminData.IsAdmin}&groupCode=${this.expandItem.GroupCode}&companyCode=${this.expandItem.CompanyCode}&departmentCode=${this.expandItem.DepartmentCode}&pageIndex=1&pageSize=100&deviceType=wd&roomNo=${this.expandItem.RoomCode}`,
          data: {},
          //假设后台需要的是表单数据这里你就可以更改
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            "Authorization": Cookies.get('Token')
          }
        }, 'yhj').then(function(res) {
          if (res.Success) {
            _this.DeviceLists = res.Data;
            // _this.TotalCount = res.TotalCount;
            if (!_this.deviceItem.Id && type === 'init') {
              if (!res.Data[0]) return;
              _this.deviceItem = {
                Id: res.Data[0].Id,
                DeviceCode: res.Data[0].DeviceCode,
                DeviceName: res.Data[0].UserDeviceName,
              }
              _this.$store.dispatch("setEnergyState", true);
              _this.initAxios();
            }
          } else {
            _this.$Message['error']({
              background: true,
              content: res.Message
            });
          }
        });
      },
      deviceChange(value) {
        let _this = this;
        _this.pageIndex = value;
        _this.GetRoshRoomAll();
      },
      // 搜索设备
      searchDevice() {
        let _this = this;
        _this.pageIndex = 1;
        _this.GetRoshRoomAll();
      },
      // 选择设备
      selectDevice(item) {
        let _this = this;
        _this.deviceItem = {
          Id: item.Id,
          DeviceCode: item.DeviceCode,
          DeviceName: item.UserDeviceName,
        }
        _this.$store.dispatch("setEnergyState", true);
        _this.initAxios();
      },
      // 加载请求
      async initAxios() {
        let _this = this;

        const x = await _this.GetNengHaoDuiBi();

        const y = await _this.GetNnegHaoTongJiByDate();

        const z = await _this.GetNengHaoTongBiData();
        
        const a = await _this.GetUserDeviceElecRank();

        _this.$store.dispatch("setEnergyState", false);
      },
      // 能耗对比axios
      GetNengHaoDuiBi() {
        let _this = this;

        const haoduibi = new Promise((resolve, reject) => {
          api({
            //这里是你自己的请求方式、url和data参数
            method: 'get',
            url: `api/YhjStatic/GetNengHaoDuiBi?deviceCode=${_this.deviceItem.DeviceCode}`,
            data: {},
            //假设后台需要的是表单数据这里你就可以更改
            headers: {
              "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
              "Authorization": Cookies.get('Token')
            }
          }, 'yhj').then(function(res) {
            resolve('yes')
            if (res.Success) {

              _this.NengHaoDuiBiItem = res.Data;

            } else {
              _this.$Message['error']({
                background: true,
                content: res.Message
              });
            }
          });
        })

        return haoduibi;

      },
      // 能耗分时统计axios
      GetNnegHaoTongJiByDate() {
        let _this = this;
        let dt = '';
        if (_this.type == 'ri') {
          dt = _this.getDate()
        }
        const haotongjiby = new Promise((resolve, reject) => {
          api({
            //这里是你自己的请求方式、url和data参数
            method: 'get',
            url: `api/YhjStatic/GetNnegHaoTongJiByDate?deviceCode=${_this.deviceItem.DeviceCode}&dt=` + dt,
            data: {},
            //假设后台需要的是表单数据这里你就可以更改
            headers: {
              "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
              "Authorization": Cookies.get('Token')
            }
          }, 'yhj').then(function(res) {
            resolve('yes')
            if (res.Success) {

              let TongJiByShowHour = [],
                TongJiByEtotal = [];
              res.Data.forEach((item, index) => {
                TongJiByShowHour.push(item.ShowHour + ':00');
                TongJiByEtotal.push(item.Etotal);
              })
              _this.TongJiByShowHour = TongJiByShowHour;
              _this.TongJiByEtotal = TongJiByEtotal;

              _this.$nextTick(() => {
                let myChart = echarts.init(document.getElementById('initTimeEcharts'));
                myChart.dispose();
                _this.initTimeEcharts(TongJiByShowHour, TongJiByEtotal);
              });

            } else {
              _this.$Message['error']({
                background: true,
                content: res.Message
              });
            }
          });
        })
        return haotongjiby;
      },
      // 能耗同比统计axios
      GetNengHaoTongBiData() {
        let _this = this, dt = '';

        if (_this.type == 'ri') {
          dt = `&dt=${_this.getDate()}`
        }

        const haotongbi = new Promise((resolve, reject) => {
          api({
            //这里是你自己的请求方式、url和data参数
            method: 'get',
            url: `api/YhjStatic/GetNengHaoTongBi?deviceCode=${_this.deviceItem.DeviceCode}&type=${_this.type}&dt=${_this.getDate()}`,
            data: {},
            //假设后台需要的是表单数据这里你就可以更改
            headers: {
              "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
              "Authorization": Cookies.get('Token')
            }
          }, 'yhj').then(function(res) {
            resolve('yes')
            if (res.Success) {

              _this.initDataEcharts(res.Data);

            } else {
              _this.$Message['error']({
                background: true,
                content: res.Message
              });
            }
          });
        })

        return haotongbi;
      },
      // 处理日月季年数据
      initDataEcharts(lists) {
        let _this = this;
        let showHours = [], zuoRiEtotals = [], jinRiEtotals = [], CreateDate1 = [], CreateDate2 = [];
        if (_this.type == 'ri') {
          lists.forEach((item, index) => {
            showHours.push(item.ShowHour + ':00');
            zuoRiEtotals.push(item.ZuoRiEtotal);
            jinRiEtotals.push(item.JinRiEtotal);
          })
        } else if (_this.type == 'yue') {
          lists.forEach((item, index) => {
            if (item.Name == this.$t('energy.energy.528939-25')) {
              jinRiEtotals.push(item.Etotal);
              let newTime = new Date(item.Date)
              let time = newTime.getDate()+this.$t('energy.energy.528939-4')
              CreateDate1.push(time);
            } else {
              zuoRiEtotals.push(item.Etotal);
              let newTime = new Date(item.Date)
              let time = newTime.getDate()+this.$t('energy.energy.528939-4')
              CreateDate2.push(time);
            }
          })
          if (CreateDate1.length > CreateDate2.length) {
              showHours = CreateDate1
          } else {
              showHours = CreateDate2
          }
        } else if (_this.type == 'ji') {
          lists.forEach((item, index) => {
            if (item.Name == this.$t('energy.energy.528939-26')) {
              jinRiEtotals.push(item.Etotal);
              showHours.push(item.Ji);
            } else {
              zuoRiEtotals.push(item.Etotal);
            }
          })
        } else {
          lists.forEach((item, index) => {
            if (item.Name == this.$t('energy.energy.528939-27')) {
              jinRiEtotals.push(item.Etotal);
              showHours.push(item.Ji + this.$t('energy.energy.528939-5'));
            } else {
              zuoRiEtotals.push(item.Etotal);
            }
          })
        }
        _this.$nextTick(() => {
          let myChart = echarts.init(document.getElementById('initEnergyEcharts'));
          myChart.dispose();
          _this.initEnergyEcharts(showHours, zuoRiEtotals, jinRiEtotals);
        });
      },
      // 能耗排行
      GetUserDeviceElecRank() {
        let _this = this,
          AdminData = JSON.parse(Cookies.get('AdminData'));
        api({
          //这里是你自己的请求方式、url和data参数
          method: 'get',
          url: `api/YhjStatic/GetUserDeviceElecRankByType?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&pageIndex=${_this.ElecRankPageIndex}&pageSize=${_this.ElecRankPageSize}&type=${_this.type}&typeValue=${_this.getDate()}`,
          data: {},
          //假设后台需要的是表单数据这里你就可以更改
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            "Authorization": Cookies.get('Token')
          }
        }, 'yhj').then(function(res) {
          if (res.Success) {

            _this.DeviceElecRankLists = res.Data;
            _this.ElecTotalCount = res.TotalCount;

          } else {
            _this.$Message['error']({
              background: true,
              content: res.Message
            });
          }
        });
      },
      EtotalIndexChange(value) {
        let _this = this;
        _this.ElecRankPageIndex = value;
        _this.GetUserDeviceElecRank();
      },
      EtotalSizeChange(value) {
        let _this = this;
        _this.ElecRankPageIndex = 1;
        _this.ElecRankPageSize = value;
        _this.GetUserDeviceElecRank();
      },
      // 时分比
      initTimeEcharts(showHour, etotal) {
        let _this = this;
        // 基于准备好的dom，初始化echarts实例
        let myChart = echarts.init(document.getElementById('initTimeEcharts'))
        // 绘制图表
        myChart.setOption({
          color: ['#37D2D4', '#19CA88', '#858FF8', '#FD9133', '#F6D10E', '#2E8CFF', '#F6580E'],
          tooltip: {
            trigger: 'axis',
          },
          grid: {
            left: '2%',
            top: '5%',
            right: '3%',
            bottom: '5%',
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            boundaryGap: false,
            data: showHour,
            axisLine: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#ccc',
                fontSize: 10
              },
            },
            axisTick: { //y轴刻度线
              show: false
            },
          }],
          yAxis: [{
            type: 'value',
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#ccc',
                fontSize: 10
              },
            },
            splitLine: {
              lineStyle: {
                color: "rgba(255,255,255,0.2)"
              }
            },
            axisTick: {
              show: false
            },
          }],
          series: [{
            name: this.$t('energy.energy.528939-23'),
            type: 'line',
            smooth: true,
            stack: this.$t('energy.energy.528939-28'),
            areaStyle: {},
            data: etotal,
            itemStyle: {
              normal: { //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(55,210,212,0.3)' // 0% 处的颜色
                }, {
                  offset: 0.5,
                  color: 'rgba(55,210,212,0.1)'
                }, {
                  offset: 1,
                  color: 'rgba(55,210,212,0.0)' // 100% 处的颜色
                }]), //背景渐变色
                lineStyle: { // 系列级个性化折线样式
                  color: 'rgba(55,210,212,1)'
                }
              },
              emphasis: {
                color: 'rgba(55,210,212,1)'
              }
            }, //线条样式

          }]
        });
        window.addEventListener('resize', function() {
          myChart.resize()
        })
      },
      // 能耗同比
      initEnergyEcharts(showHours, zuoRiEtotals, jinRiEtotals) {
        let _this = this;
        // 基于准备好的dom，初始化echarts实例
        let myChart = echarts.init(document.getElementById('initEnergyEcharts'))
        // 绘制图表
        myChart.setOption({
          color: ['#858FF8', '#19CA88', '#858FF8', '#FD9133', '#F6D10E', '#2E8CFF', '#F6580E'],
          tooltip: {
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            left: '2%',
            top: '5%',
            right: '3%',
            bottom: '5%',
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            data: showHours,
            axisLine: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#ccc',
                fontSize: 10
              },
            },
            axisTick: { //y轴刻度线
              show: false
            },
          }],
          yAxis: [{
            type: 'value',
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#ccc',
                fontSize: 10
              },
            },
            splitLine: {
              lineStyle: {
                color: "rgba(255,255,255,0.2)"
              }
            },
            axisTick: {
              show: false
            },
          }],
          series: [{
              name: this.$t('energy.energy.528939-29'),
              type: 'bar',
              barMaxWidth: '50',
              barMinHeight: 2,
              data: zuoRiEtotals
            },
            {
              name: this.$t('energy.energy.528939-30'),
              type: 'bar',
              barMaxWidth: '50',
              barMinHeight: 2,
              data: jinRiEtotals
            },
          ],
          dataZoom: {
            type: 'inside',
            start: 0,
            end: 100
          },
        });
        window.addEventListener('resize', function() {
          myChart.resize()
        })
      },
      // 查询
      inquireClick() {
        let _this = this;
        _this.GetNengHaoTongBiData();
        _this.GetUserDeviceElecRank();
        _this.GetNnegHaoTongJiByDate();
      },
      // 导出
      exportClick() {
        let _this = this;
        api({
          //这里是你自己的请求方式、url和data参数
          method: 'get',
          url: `api/YhjStatic/Export_NengHao?deviceCode=${_this.deviceItem.DeviceCode}&type=${_this.type}&dt=${_this.getDate()}`,
          data: {},
          //假设后台需要的是表单数据这里你就可以更改
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            "Authorization": Cookies.get('Token')
          }
        }, 'yhj').then(function(res) {
          if (res.Success) {

            window.location.href = res.Data;

          } else {
            _this.$Message['error']({
              background: true,
              content: res.Message
            });
          }
        });
      },
      // 获取时间格式
      getDate() {
        let _this = this;
        let dt1 = _this.formDate(_this.dt).split(' ');
        let dt2 = dt1[0].split('-');
        let dt = '';
        if (_this.type == 'ri') {
          dt = dt1[0];
        } else {
          if (dt2[0]) {
            dt = `${dt2[0]}-${dt2[1]}`
          }
        }
        return dt;
      },
      // 时间转换
      formDate(dateForm) {
        if (!dateForm) {
          return "";
        } else {
          var dateee = new Date(dateForm).toJSON();
          var date = new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(
            /\.[\d]{3}Z/, '');
          return date;
        }
      },
    }
  }
</script>

<style scoped="scoped" lang="scss">
  /* @import url("./energy.css"); */
  @import "./energy_default.scss";
  @import "./energy.scss";
</style>



// WEBPACK FOOTER //
// src/components/report/energy/energy.vue